var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5999C8.02999 21.5999 4.79999 18.5578 4.79999 14.8186C4.79999 9.5999 12.0001 2.3999 12.0001 2.3999C12.0001 2.3999 19.2 9.5999 19.2 14.8186C19.2 18.5579 15.9701 21.5999 12 21.5999Z",
    fill: "#6DBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 14.3999C15.0642 16.0763 13.7176 17.4167 12 17.9999",
    stroke: "#F9FBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.7564c5750e8f0e65a742a4e17053f685.svg";
export { ForwardRef as ReactComponent };